// extracted by mini-css-extract-plugin
export default {"fixSize":"styles-module__fixSize____Qdgy","cardError":"styles-module__cardError___dXbLA"};